import React from 'react';
import { withLayout } from '../../Layout/Layout';
import { HotelReviewsList } from '../../components';
import { httpGet } from '../../utils/httpClient';
import { DestinationPage } from '../../components/DestinationPage/DestinationPage';

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps = async ({ params }) => {
  const country = params.all[0];
  const city = params.all[1];
  const isHotelsPage = params.all.includes('hotels');
  const res = await httpGet(
    `${process.env.javaApiUrl}/destinations/${country}/${city}`
  );
  const destination = await res.json();

  if (destination.error) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }

  return {
    props: {
      country,
      city,
      isHotelsPage,
      destination,
    },
    revalidate: 60,
  };
};

function Destination({ country, city, isHotelsPage, destination }) {
  const destinationObj = { country, city };
  const title = `Hotels in ${destination.city !== '-' ? destination.city : ''}${
    destination.city !== '-' ? ',' : ''
  } ${destination.country}`;

  return isHotelsPage ? (
    <HotelReviewsList
      type="destination"
      listTitle={title}
      country={destinationObj.country}
      city={destinationObj.city}
    />
  ) : (
    <div>
      <DestinationPage data={{ destination, country, city }} />
    </div>
  );
}

export default withLayout(Destination, true);
